// @ts-nocheck
import { CheckboxFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { TextFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { ImagePickerFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { videoPreloadOptions, videoTypeOptions } from "@store/Library/Components/Toolkit/Video/Video";
import { getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";
import { FilePickerFieldDefinition } from "@toolkit/Framework/Types/FieldDefinition";

export const videoAutoplayField = {
    displayName: "Autoplay",
    editorTemplate: "CheckboxField",
    fieldType: "General",
    tooltip: "The video will automatically start playing.",
    tooltipPosition: "left",
} as CheckboxFieldDefinition;

export const videoControlsField = {
    displayName: "Controls",
    editorTemplate: "CheckboxField",
    defaultValue: true,
    fieldType: "General",
    tooltip: "The video controls will be displayed.",
    tooltipPosition: "left",
} as CheckboxFieldDefinition;

export const videoHeightField = {
    displayName: "Height",
    editorTemplate: "TextField",
    defaultValue: "",
    fieldType: "Contextual",
    tooltip: "The height of the video.",
    tooltipPosition: "left",
} as TextFieldDefinition;

export const videoLoopField = {
    displayName: "Loop",
    editorTemplate: "CheckboxField",
    fieldType: "General",
    tooltip: "The video will start over again, every time it is finished.",
    tooltipPosition: "left",
} as CheckboxFieldDefinition;

export const videoMutedField = {
    displayName: "Muted",
    editorTemplate: "CheckboxField",
    defaultValue: true,
    fieldType: "General",
    tooltip: "The audio output of the video will be muted.",
    tooltipPosition: "left",
} as CheckboxFieldDefinition;

export const videoPosterField = {
    displayName: "Poster",
    editorTemplate: "ImagePickerField",
    defaultValue: "",
    fieldType: "Contextual",
    tooltip: "Image to be shown while the video is downloading, or until the user hits the play button.",
    tooltipPosition: "left",
} as ImagePickerFieldDefinition;

export const videoPreloadField = {
    ...getDataOptionsFieldDefinition(videoPreloadOptions),
    displayName: "Preload",
    tooltip: "Specifies if and how the video will be loaded when the page loads.",
    tooltipPosition: "left",
} as DropDownFieldDefinition<string>;

export const videoSourceEmbedField = {
    displayName: "Url",
    editorTemplate: "TextField",
    defaultValue: "",
    fieldType: "Contextual",
    tooltip: "Url to an external video like YouTube or Vimeo. Be sure to use the embeded video link.",
    tooltipPosition: "left",
} as TextFieldDefinition;

export const videoSourceMediaLibraryField = {
    displayName: "Video",
    editorTemplate: "FilePickerField",
    defaultValue: "",
    fieldType: "Contextual",
} as FilePickerFieldDefinition;

export const videoSourceUrlField = {
    displayName: "Url",
    editorTemplate: "TextField",
    defaultValue: "",
    fieldType: "Contextual",
    tooltip: "Url to an external video.",
    tooltipPosition: "left",
} as TextFieldDefinition;

export const videoTypeField = {
    ...getDataOptionsFieldDefinition(videoTypeOptions),
    displayName: "Type",
    tooltip: "Specifies the Internet media type (formerly known as MIME type) of the video.",
    tooltipPosition: "left",
} as DropDownFieldDefinition<string>;

export const videoWidthField = {
    displayName: "Width",
    editorTemplate: "TextField",
    defaultValue: "",
    fieldType: "Contextual",
    tooltip: "The width of the video.",
} as TextFieldDefinition;
